import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import BulkImeiService from "src/service/bulkdeviceadd";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update Device",
  },
];

const validationSchema = yup.object({
  imei_no: yup
    .string("Enter Imei No")
    .matches(/^[0-9]{10,20}$/, "Invalid Imei no")
    .required("Imei no is Required"),
});

const UpdateBulkDevice = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    imei_no: "",
    c_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {
        const res = await BulkImeiService.get_imei_list({
          id: param.id,
        });

        setInitialValues({
          id: param.id,
          imei_no: res.data[0].imei_no,
          device_name: res.data[0].device_name,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchDeviceData();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // Create a new object excluding device_name
        const { device_name, ...restValues } = values;

        try {
          const res = await BulkImeiService.update_imei_data(restValues);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/bulkdevicelist");
          }, 1000);
        } catch (error) {
          swal("error", error.message || error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title="Update Device" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Device
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/bulkdevicelist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "0px" }}>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="imei_no">
                Device Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="device_name"
                name="device_name"
                type="text"
                value={values.device_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.device_name && Boolean(errors.device_name)}
                helperText={touched.device_name && errors.device_name}
                variant="outlined"
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="imei_no">
                Imei No. <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="imei_no"
                name="imei_no"
                type="text"
                value={values.imei_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.imei_no && Boolean(errors.imei_no)}
                helperText={touched.imei_no && errors.imei_no}
                variant="outlined"
                placeholder="Enter Imei No."
                fullWidth
              />
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateBulkDevice;
